export default {
  methods: {
    // toast simple solo para mostrar un mensaje sin link
    lmToastSuccessMessage (toastMessage, toastTitle, autoHideDelay = 5000) {
      this.$root.$bvToast.toast(toastMessage, {
        title: toastTitle,
        toaster: 'b-toaster-top-center',
        variant: 'success',
        autoHideDelay: process?.env?.VUE_APP_TOAST_AUTOHIDEDELAY || autoHideDelay,
        solid: true
      })
    },
    // toast danger solo para mostrar un mensaje sin link
    lmToastDangerMessage (toastMessage, toastTitle, autoHideDelay = 5000) {
      this.$root.$bvToast.toast(toastMessage, {
        title: toastTitle,
        toaster: 'b-toaster-top-center',
        variant: 'danger',
        autoHideDelay: process?.env?.VUE_APP_TOAST_AUTOHIDEDELAY || autoHideDelay,
        solid: true
      })
    },
    lmToastSuccessInternalLink (routerLinkToPropoty, textRouterLinkToPropoty, toastTitle) {
      // toast para mostrar un mensaje y un link
      const h = this.$createElement
      const vNodesMsg = h(
        'p',
        { class: 'mb-0' },
        [
          h('router-link', {
            props: {
              to: routerLinkToPropoty
            }
          }, textRouterLinkToPropoty)
        ]
      )
      this.$root.$bvToast.toast(vNodesMsg, {
        id: 'lm-toast-success-internal-link',
        title: toastTitle,
        toaster: 'b-toaster-top-center',
        variant: 'success',
        autoHideDelay: process?.env?.VUE_APP_TOAST_AUTOHIDEDELAY,
        solid: true
      })
    },
    getOriginNotificationLink (url) {
      const pathArray = url.split('/')
      const protocol = pathArray[0]
      const host = pathArray[2]
      return protocol + '//' + host
    },
    lmToastSuccessPushNotification (link, title, icon, body) {
      const originLink = this.getOriginNotificationLink(link)
      const pathLink = link.replace(originLink, '')
      const appOrigin = window.location.origin
      const areOriginsAppAndLinkEquals = appOrigin === this.getOriginNotificationLink(link)
      const elementToCreate = {
        tag: areOriginsAppAndLinkEquals ? 'router-link' : 'a',
        attr: areOriginsAppAndLinkEquals ? 'to' : 'href',
        link: areOriginsAppAndLinkEquals ? pathLink : link
      }
      const h = this.$createElement
      const vNodesTitle = h(
        elementToCreate.tag,
        {
          class: ['d-flex', 'flex-grow-1', 'align-items-baseline', 'mr-2'],
          attrs: {
            [elementToCreate.attr]: elementToCreate.link
          }
        },
        [
          h('strong', { class: 'mr-2' }, title),
          h(
            'img',
            { class: 'ml-auto',
              attrs: {
                id: 'foo',
                src: icon,
                width: 32,
                heigth: 32
              }
            })
        ]
      )
      const vNodesMsg = h(elementToCreate.tag, { attrs: { [elementToCreate.attr]: elementToCreate.link } }, body)
      this.$bvToast.toast(vNodesMsg, {
        title: [vNodesTitle],
        autoHideDelay: process?.env?.VUE_APP_TOAST_AUTOHIDEDELAY,
        variant: 'info'
      })
    }
  },
  created () {
    const allIdToastToHideWhenMixinsIsCreated = ['lm-toast-success-internal-link']
    allIdToastToHideWhenMixinsIsCreated.forEach(idToast => {
      this.$bvToast.hide(idToast)
    })
  }
}
